var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var verticalListItem = require('../components/verticalListItem');
var paginationWithSearch = require('../data/components/paginationWithSearch');

function urlForRecord (record) {
  return '/api/v1/' + record['@class'].toLowerCase() + '/' + record['@rid'].slice(1);
}

function childrenForRecord(record, tree) {
  return record && tree && tree.edgeClass ? (record['out_' + tree.edgeClass] || []) : [];
}

function childVertex(child) {
  return child && (child.in || child['in_Source'] || child);
}

function normalizeChildForSearch(child) {
  var vertex = childVertex(child);
  if (!vertex) return child;
  return Object.assign({}, child, {
    name: vertex.name || child.name || '',
    '@rid': vertex['@rid'] || child['@rid'],
    '@class': vertex['@class'] || child['@class']
  });
}

function isTreeRoot(child) {
  return child && child.isTreeRoot;
}

function hasChildren(vertex, tree) {
  return childrenForRecord(vertex, tree).length > 0;
}

function isRenderableChild(child, activeTree) {
  if (typeof child === 'function') child = child();
  if (!child) return false;
  if (isTreeRoot(child)) return true;

  var vertex = childVertex(child);
  if (!(vertex && vertex.name) && !child.name) return false;
  if (!vertex || !vertex['@class']) return false;
  if (activeTree && vertex['@class'] === activeTree.leafClass) return true;
  if (activeTree && vertex['@class'] !== activeTree.leafClass) return true;
  return hasChildren(vertex, activeTree);
}

var trees = {};

trees.oninit = function (vnode) {
  var ctrl = this;
  ctrl.trees = vnode.attrs.trees;
  ctrl.selector = vnode.attrs.selector;
  ctrl.pageSize = vnode.attrs.pageSize || 10;
  ctrl.node = prop({});
  ctrl.activeTree = {};
  ctrl.roots = [];
  ctrl.rootNode = null;
  ctrl.newNode = prop(false);
  ctrl.dataToShow = [];

  ctrl.rootEntryFor = function (rootResult, tree, idx) {
    return {
      name: tree.name || 'Home',
      treeIndex: idx,
      isTreeRoot: true,
      children: childrenForRecord(rootResult, tree)
    };
  };

  ctrl.getActiveTree = function () {
    return ctrl.activeTree || {};
  };

  ctrl.setActiveTree = function (tree) {
    ctrl.activeTree = tree || {};
  };

  ctrl.resetPage = function () {
    ctrl.dataToShow.length = 0;
    ctrl.newNode(true);
  };

  ctrl.getRoots = function () {
    ctrl.node({children: []});
    Promise.all(ctrl.trees.map(function (tree) {
      return loaders.requestWithLoader({
        loader: 'background',
        url: tree['@id'],
        method: 'GET'
      });
    })).then(function (results) {
      ctrl.roots = results.map(function (rootResult, idx) {
        return ctrl.rootEntryFor(rootResult, ctrl.trees[idx], idx);
      });
      ctrl.rootNode = {
        children: ctrl.roots,
        '@rid': results[0] && results[0]['@rid'],
        '@class': results[0] && results[0]['@class'],
        name: results[0] && results[0].name || ctrl.trees[0] && ctrl.trees[0].name,
        ancestors: []
      };
      ctrl.node(ctrl.rootNode);
      if (!ctrl.getActiveTree().leafClass) {
        ctrl.setActiveTree(ctrl.trees[0] || {});
      }
      ctrl.resetPage();
      m.redraw();
    });
  };

  ctrl.home = function () {
    ctrl.node(ctrl.rootNode || {children: ctrl.roots});
    ctrl.resetPage();
  };

  ctrl.selectTree = function (root) {
    if (root && typeof root.treeIndex === 'number') {
      ctrl.setActiveTree(ctrl.trees[root.treeIndex]);
      return;
    }
    ctrl.setActiveTree(ctrl.trees.find(function (tree) {
      return root && tree && root.name === tree.name;
    }));
  };

  ctrl.navigateNode = function (node) {
    var activeTree = ctrl.getActiveTree();
    if (!activeTree.leafClass) {
      activeTree = ctrl.trees[0] || {};
      ctrl.setActiveTree(activeTree);
    }

    if (!node['@class']) {
      var rootEntry = node && typeof node.treeIndex === 'number' && ctrl.roots[node.treeIndex]
        ? ctrl.roots[node.treeIndex]
        : node;
      ctrl.selectTree(rootEntry);
      ctrl.node(rootEntry);
      ctrl.resetPage();
      return;
    }

    var currentNode = ctrl.node();
    return loaders.requestWithLoader({
      loader: 'background',
      url: urlForRecord(node),
      method: 'GET'
    })
    .then(function (res) {
      var ancestorClass = activeTree.ancestorClass;
      if (ancestorClass && (!res[ancestorClass] || res[ancestorClass].length === 0)) {
        var currentAncestors = currentNode && currentNode[ancestorClass] ? currentNode[ancestorClass].slice() : [];
        if (currentNode && currentNode['@rid']) {
          currentAncestors.push({
            name: currentNode.name || 'Home',
            '@rid': currentNode['@rid'],
            '@class': currentNode['@class']
          });
        }
        res[ancestorClass] = currentAncestors;
      }
      ctrl.node(res);
      ctrl.resetPage();
      m.redraw();
    });
  };

  ctrl.selectNode = function (node) {
    return ctrl.selector(node);
  };

  ctrl.getRoots();
};

function rootRow(ctrl, child) {
  var rootEntry = child && typeof child.treeIndex === 'number' && ctrl.roots ? ctrl.roots[child.treeIndex] : child;
  var openRoot = function (event) {
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
    ctrl.navigateNode(rootEntry);
  };

  return m(verticalListItem, {
    label: m('span', [
      child.name,
      m('i', {class: 'dark-blue ion-ios-arrow-right ml2 f3 b'})
    ]),
    labelClass: 'dark-blue',
    onclick: openRoot,
    onclickLabel: openRoot
  }, [
    m('i', {class: 'fr ion-ios-arrow-right'})
  ]);
}

function branchRow(ctrl, vertex, activeTree) {
  var openBranch = function (event) {
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
    ctrl.navigateNode(vertex);
  };

  return m(verticalListItem, {
    label: m('span', [
      vertex.name,
      m('i', {class: 'dark-blue ion-ios-arrow-right ml2 f3 b'})
    ]),
    labelClass: 'dark-blue',
    onclick: openBranch,
    onclickLabel: openBranch
  }, [
    m('i', {class: 'fr ion-ios-arrow-right'})
  ]);
}

function leafRow(ctrl, vertex) {
  return m(verticalListItem, {label: vertex.name, onclick: ctrl.selectNode.bind(this, vertex)}, [
    m('i', {class: 'fr ' + (ctrl.selector()['@rid'] === vertex['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
  ]);
}

function renderChild(ctrl, child, activeTree) {
  if (typeof child === 'function') child = child();
  if (!child || !child.name) return null;

  if (isTreeRoot(child)) {
    return rootRow(ctrl, child);
  }

  var vertex = childVertex(child);
  if (!vertex || !vertex['@class']) return null;

  if (activeTree && vertex['@class'] === activeTree.leafClass) {
    return leafRow(ctrl, vertex);
  }

  if (activeTree && vertex['@class'] !== activeTree.leafClass) {
    return branchRow(ctrl, vertex, activeTree);
  }

  if (hasChildren(vertex, activeTree)) {
    return branchRow(ctrl, vertex, activeTree);
  }

  return null;
}

trees.view = function () {
  var ctrl = this;
  var activeTree = ctrl.getActiveTree();
  var ancestors = activeTree && activeTree.ancestorClass ? ctrl.node()[activeTree.ancestorClass] : ctrl.node().ancestors;
  var displayAncestors = Array.isArray(ancestors) ? ancestors.slice().filter(function (ancestor) {
    return !ancestor || ancestor.name !== 'root';
  }) : [];
  var rootRid = ctrl.rootNode && ctrl.rootNode['@rid'];
  var isAtRoot = ctrl.node()['@rid'] === rootRid;
  var children = ctrl.node().children || childrenForRecord(ctrl.node(), activeTree);
  children = Array.isArray(children) ? children : [];
  var searchableChildren = children.filter(function (child) {
    return isRenderableChild(child, activeTree);
  }).map(normalizeChildForSearch);
  var resultsStyle = searchableChildren.length > ctrl.pageSize
    ? {minHeight: (ctrl.pageSize * 44) + 'px'}
    : {};
  var placeHolder = isAtRoot ? 'Search dashboard' : (activeTree.leafClass === 'Element' ? 'Search sheet' : 'Search');

  return m('div', [
    m('label', 'Select Node:'),
    m('br'),
    m('div.mb3.pb2.bb.bw1.b--mid-gray.near-white', [
      isAtRoot ? null : m('div.dib-ns.mr2.blue.pointer', {onclick: ctrl.home}, [
        'Home',
        ' / '
      ]),
      displayAncestors.map(function (ancestor, idx) {
        var isLast = (idx + 1) === displayAncestors.length;
        return m('div.dib-ns.mr2', {
          class: isLast ? 'active' : 'blue',
          onclick: ctrl.navigateNode.bind(this, ancestor)
        }, [
          ancestor.name,
          ' / '
        ]);
      })
    ]),
    m(paginationWithSearch, {
      data: searchableChildren,
      dataToShow: ctrl.dataToShow,
      newNode: ctrl.newNode,
      itemsPerPage: ctrl.pageSize,
      placeHolder: placeHolder,
      fieldsToSearch: ['name']
    }, [
      ctrl.dataToShow.some(function (child) { return child && child.name; })
        ? m('div.report-tree-picker-results', {style: resultsStyle}, ctrl.dataToShow.map(function (child) {
          return renderChild(ctrl, child, activeTree);
        }))
        : m('div.moon-gray.pv2', 'No results')
    ])
  ]);
};

module.exports = trees;
